import React, {useState} from 'react'
import {api} from './api'
import {InstallOnboarding} from './Install'

export default function Auth({onAuthed}) {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [err, setErr] = useState('')
  const [busy, setBusy] = useState(false)
  const [confirmNew, setConfirmNew] = useState(false)
  const [welcome, setWelcome] = useState(null) // set to the new user after signup

  // brand-new account → show the add-to-home-screen step before entering the app
  if (welcome) {
    return (
      <div className="auth">
        <div className="auth-card">
          <div className="welcome-title">Welcome, @{welcome.username}</div>
          <div className="welcome-sub">Add yoked to your home screen so it opens like an app.</div>
          <InstallOnboarding />
          <button className="btn btn-ghost btn-block" onClick={() => onAuthed(welcome)} style={{marginTop: 14}}>
            Continue →
          </button>
        </div>
      </div>
    )
  }

  // editing either field clears any pending prompt/error
  const edit = setter => v => {
    setter(v)
    setConfirmNew(false)
    setErr('')
  }

  // arrow → try to log in. new username → offer to create the account.
  const go = async e => {
    e && e.preventDefault()
    if (!username.trim() || !password || busy) return
    setErr('')
    setConfirmNew(false)
    setBusy(true)
    try {
      const user = await api.login(username.trim(), password)
      onAuthed(user)
    } catch (e2) {
      setBusy(false)
      if (e2.code === 'no_user') setConfirmNew(true)
      else setErr(e2.message)
    }
  }

  const createAccount = async () => {
    setBusy(true)
    setErr('')
    try {
      const user = await api.signup(username.trim(), password)
      setWelcome(user) // show the "add to home screen" step first
    } catch (e2) {
      setBusy(false)
      setConfirmNew(false)
      setErr(e2.message)
    }
  }

  return (
    <div className="auth">
      <form className="auth-card" onSubmit={go}>
        <input
          className="input"
          placeholder="username"
          autoCapitalize="none"
          autoCorrect="off"
          autoComplete="username"
          value={username}
          onChange={e => edit(setUsername)(e.target.value)}
        />
        <div className="auth-row">
          <input
            className="input"
            type="password"
            placeholder="password"
            autoComplete="current-password"
            value={password}
            onChange={e => edit(setPassword)(e.target.value)}
          />
          <button className="auth-go" type="submit" disabled={busy || !username.trim() || !password} aria-label="continue">
            →
          </button>
        </div>

        {err && <div className="auth-err">{err}</div>}

        {confirmNew && (
          <div className="auth-confirm">
            <div className="auth-confirm-q">
              New here — make an account for <b>@{username.trim().toLowerCase()}</b>?
            </div>
            <button type="button" className="btn btn-primary btn-block" onClick={createAccount} disabled={busy}>
              Yes, create account
            </button>
          </div>
        )}
      </form>
    </div>
  )
}
